<kodit-dropdown
  [options]="items"
  [formCtrlId]="formCtrlId"
  [formCtrl]="formCtrl"
  ctrlPlaceholder="Odaberite korisničku grupu"
></kodit-dropdown>
